import { refresh } from '../utils';
import { errorRoute, purchaseProcessingRoute, appInstallationRoute } from './shared';

export default [
  appInstallationRoute,
  purchaseProcessingRoute,
  errorRoute,
  {
    name: 'app-details',
    path: '/',
    component: () => refresh(import('@/views/Details/index.vue')),
  },
  {
    name: 'app-download',
    path: '/download',
    component: () => refresh(import('@/views/Details/Download.vue')),
  },
  {
    path: '*',
    redirect: {
      path: '/',
    },
  },
];
